import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';
import { PagerComponent } from './component/pager.component';

import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { EquipmentLogModule } from "../../../../tmc-common/common/components/equipment-log/equipment-log.module";


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    SharedModule,
    ApplicationClientCommonModule,
    EquipmentLogModule
],
  declarations: [
    PagerComponent
  ]
})
export class PagerModule { }

